import { configureStore } from "@reduxjs/toolkit";
import categoryReducer from "../features/categories/categorySlice";
import salesReducer from "../features/sales/salesSlice";
import accountReducer from "../features/account/accountSlice";
export const store = configureStore({
  reducer: {
    category: categoryReducer,
    sales: salesReducer,
    account: accountReducer,
  },
});
